export const INTERACTION_TYPES_ENTITLEMENT = {
    INDIVIDUAL: 'SEARCH_BY_TAXNUMBER',
    BILLING_ACCOUNT: undefined,
    PRODUCT: undefined,
    ACCESS: undefined
};
